import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-lg-9 mx-auto overflow-x-hidden" }
const _hoisted_2 = { class: "text-center mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "px-3"
}
const _hoisted_4 = { class: "container-fluid" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["href"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }

import { ref, computed, watch } from "vue";
    import { useStore } from "vuex";
    import FinalSalarySchemeSupport from "@/guiide/components/common/DBOptions/FinalSalarySchemeSupport.vue";
    import FinalSalaryScheme from "@/guiide/ts/assets/finalsalary/finalSalaryScheme";
    import { useUIContent } from "@/guiide/ts/configuration/useUIContent";

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Support',
  setup(__props) {

    const { text, textArray } = useUIContent();

    const store = useStore();

    const schemeInfo = ref<FinalSalaryScheme | null>(null);

    const schemeWebsite = ref<string | null>(text('dboptions.scheme.contact.website'));
    const schemeEmail = ref<string | null>(text('dboptions.scheme.contact.email'));
    const schemePhoneNo = ref<string | null>(text('dboptions.scheme.contact.phone-number'));
    const schemeAddress = ref<string[] | null>(textArray('dboptions.scheme.contact.address'));

    const schemeHasContactDetails = computed(() =>
        [schemeWebsite.value, schemeEmail.value, schemePhoneNo.value, schemeAddress.value.length].some(Boolean)
    );

    watch(
        () => store.state.retiree,
        async () => {
            await getScheme();
        }
    );

    async function getScheme() {
        if (!store.state.retiree) {
            return;
        }

        schemeInfo.value = store.state.retiree.finalSalaries?.schemes[0];
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "skin-page-heading" }, " Support ", -1)),
      (schemeInfo.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Here are the support options available to you in the " + _toDisplayString(schemeInfo.value.name) + ". ", 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (schemeInfo.value)
        ? (_openBlock(), _createBlock(FinalSalarySchemeSupport, {
            key: 0,
            schemeSupportMode: schemeInfo.value.supportMode
          }, null, 8, ["schemeSupportMode"]))
        : _createCommentVNode("", true),
      _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "my-5 mx-5" }, null, -1)),
      (schemeHasContactDetails.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("p", { class: "fw-bold" }, "For questions about your Scheme benefits", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("p", { class: "mb-3" }, "If you have questions about your benefits under the Scheme, please contact the Scheme Administrators using the details below:", -1)),
            (schemeWebsite.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                  _cache[1] || (_cache[1] = _createTextVNode("Website: ")),
                  _createElementVNode("a", {
                    href: schemeWebsite.value,
                    target: "_blank"
                  }, _toDisplayString(schemeWebsite.value), 9, _hoisted_7)
                ]))
              : _createCommentVNode("", true),
            (schemeEmail.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Email: " + _toDisplayString(schemeEmail.value), 1))
              : _createCommentVNode("", true),
            (schemePhoneNo.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Phone number: " + _toDisplayString(schemePhoneNo.value), 1))
              : _createCommentVNode("", true),
            (schemeAddress.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mb-2" }, "Address:", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schemeAddress.value, (p, i) => {
                    return (_openBlock(), _createElementBlock("p", {
                      key: i,
                      class: "ms-2 mb-0 fst-italic"
                    }, _toDisplayString(p), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _cache[5] || (_cache[5] = _createElementVNode("hr", { class: "my-5 mx-5" }, null, -1))
          ]))
        : _createCommentVNode("", true),
      _cache[7] || (_cache[7] = _createElementVNode("div", null, [
        _createElementVNode("p", { class: "fw-bold" }, "For general information about pensions and retirement"),
        _createElementVNode("p", null, [
          _createElementVNode("a", {
            href: "https://www.moneyhelper.org.uk",
            target: "_blank"
          }, "MoneyHelper"),
          _createTextVNode(" is an independent service set up by the Government to help people make the most of their money. It provides information about financial planning and saving, including information about the different types of financial advice available, where to look for an FCA regulated financial adviser and the questions to ask them. ")
        ])
      ], -1))
    ])
  ]))
}
}

})